let SplashMessage = {
  version: 8,
  title: "Enjoy Dawntrail!",
  messages: ["Added Viper and Pictomancer (thanks mally)."]
};
export default SplashMessage;
